import { render, staticRenderFns } from "./MapView.vue?vue&type=template&id=97b900be&"
import script from "./MapView.vue?vue&type=script&lang=js&"
export * from "./MapView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b900be')) {
      api.createRecord('97b900be', component.options)
    } else {
      api.reload('97b900be', component.options)
    }
    module.hot.accept("./MapView.vue?vue&type=template&id=97b900be&", function () {
      api.rerender('97b900be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MapView.vue"
export default component.exports